import { useSearchParams } from 'react-router-dom'
import { useIsDeviceWidth, DeviceWidth } from '@/utils/deviceWidthHelpers'
import { Card, Image, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import { fetchFreeTrialLength } from './helpers'

export const FreeTrialSignupBanner = () => {
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  const [searchParams] = useSearchParams()
  const freeTrialSearchParamValue = searchParams.get('trial')

  const freeTrialDays = fetchFreeTrialLength(freeTrialSearchParamValue)

  return (
    <Card className="w-full px-10 py-5">
      <div className="flex items-center justify-center">
        <div className="flex w-1/4 justify-center">
          <Image
            src="https://heard-images.s3.amazonaws.com/assets/book-celebration.svg"
            alt="banner"
            className="h-[100px]"
          />
        </div>

        <div className="w-3/4">
          <Text
            variant={TypographyStyles.H2}
            textAlign={isMobile ? 'center' : undefined}
          >
            Try Heard for free
          </Text>

          <Text
            variant={TypographyStyles.BODY_MD}
            color={TextColors.MUTED}
            textAlign={isMobile ? 'center' : undefined}
          >
            Start your {freeTrialDays} day free trial, and learn how Heard can
            transform and simplify your practice finances. We&apos;ll remind you
            when you have a few days left in your trial.
          </Text>
        </div>
      </div>
    </Card>
  )
}
